import React, { useState, useReducer, useEffect, useCallback } from "react"
import { navigate } from "gatsby"
import axios from "axios"

const readUsernames =
  "f5524c7172146e0a641eaa6a9674730b26b016c9b68917affb0e72f8f33c6df2fb05f4627a44c7d6d9d0f66a1ff9921a61ba0f1c670623e642485e12823b9c75a54a30e22bb9b9e90672c196ebc01ff6766668ffa7c96ab7d14621079fd79ff55edeacdd8dfcb7f3fde3d21b1d0e82e823f35fed1d9d67a8a3918316459d89b5"

export const Context = React.createContext({})

const errorReducer = (state, action) => {
  if (action.type === "ERROR") {
    return {
      error: {
        have: true,
        status: action.val.status,
        message: action.val.data.error.message,
      },
    }
  }

  return {
    error: {
      have: false,
      status: "",
      message: "",
    },
  }
}

const UserProvider = props => {
  let success = true
  let nameCheckFail = false

  const [errorState, dispatchError] = useReducer(errorReducer, {
    error: {
      have: false,
      status: "",
      message: "",
    },
  })

  const [logedIn, setLogedIn] = useState(false)
  const [loading, setLoading] = useState(false)
  const [resetForm, setResetForm] = useState(1)
  const [nameDuplication, setNameDuplication] = useState(false)
  const [userGlobalState, setUserGlobalState] = useState(null)
  const [signInMode, setSignInMode] = useState(true)
  const [registerMailSend, setRegiserMailSend] = useState(false)
  const [resetPassSend, setResetPassSend] = useState(false)
  const [passChanged, setpassChanged] = useState(false)

  //SIGN UP LOGIC

  const signInTest = () => {
    setLogedIn(!logedIn)
    console.log(logedIn)
  }

  const signUpChildHandler = (data, number = null) => {
    console.log(data)
  }

  const resetError = () => {
    dispatchError({ type: "RESET" })
  }

  //use can use ctx.setNameDuplication out of the store

  const resetNameDupCheck = () => {
    setNameDuplication(false)
  }

  const sendRegistrate = data => {
    console.log("SENDING")
    console.log(data)

    axios
      .post("https://montessori-back.herokuapp.com/api/auth/local/register", {
        username: data.userName,
        email: data.email,
        password: data.pass,
      })
      .then(response => {
        console.log("User profile", response.data.user)
        console.log("User token", response.data.jwt)
      })
      .catch(error => {
        if (
          error.response.data.error.message !==
          "An error occurred during account creation"
        ) {
          success = false
          dispatchError({ type: "ERROR", val: error.response })
          setLoading(false)
          console.log("An error occurred:", error.response)
          console.log("An error occurred:", error.response.data.error.message)
        }
      })
      .finally(() => {
        console.log("POST FINALLY")
        if (success === true) {
          // navigate("/welcome")
          setLoading(false)
          setRegiserMailSend(true)
          setResetForm(state => {
            return state + 1
          })
        }
      })
  }
  // const commentDataHandler = (data) => {
  //   setCommentData(data)

  const sendAccData = async data => {
    setLoading(true)
    axios
      .get("https://montessori-back.herokuapp.com/api/Users", {
        headers: {
          Authorization: `Bearer ${readUsernames}`,
        },
      })
      .then(response => {
        response.data.forEach(ele => {
          if (ele.username === data.userName) {
            nameCheckFail = true
            setNameDuplication(true)
            setLoading(false)
          }
        })
      })
      .catch(error => {
        console.log(error.response)
      })
      .finally(() => {
        if (!nameCheckFail) {
          sendRegistrate(data)
          setNameDuplication(false)
        }
      })
  }

  //SIGN IN IN LOGIC

  const logInHandler = useCallback(data => {
    let userData
    setLoading(true)

    axios
      .post("https://montessori-back.herokuapp.com/api/auth/local", {
        identifier: data.email,
        password: data.pass,
      })
      .then(response => {
        userData = response.data
        console.log(userData)
      })
      .catch(error => {
        dispatchError({ type: "ERROR", val: error.response })
        console.log("An error occurred:", error.response)
        console.log("we have an error")
        success = false
      })
      .finally(() => {
        if (success) {
          if (typeof window !== "undefined") {
            localStorage.setItem("MontesoriUser", JSON.stringify(userData))
          }

          autoLogIn()
          navigate("/courses")
          setResetForm(state => {
            return state + 1
          })
        }
        setLoading(false)
      })
  })

  const logOutHandler = () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("MontesoriUser")
      setUserGlobalState(null)
      navigate("/")
    }
  }

  const autoLogIn = () => {
    let localUser
    if (typeof window !== "undefined") {
      localUser = localStorage.getItem("MontesoriUser")
    }
    const userData = JSON.parse(localUser)

    if (userData) {
      setUserGlobalState({
        name: userData.user.username,
        email: userData.user.email,
        token: userData.jwt,
        userId: userData.user.id,
      })
    } else {
      // navigate("/")
    }
  }

  const sendForgottenPasss = async data => {
    setLoading(true)

    axios
      .post("https://montessori-back.herokuapp.com/api/auth/forgot-password", {
        email: data,
      })
      .then(response => {
        // Handle success.
        console.log(response)
        console.log("Your user received an email")
      })
      .catch(error => {
        // Handle error.
        console.log("An error occurred:", error.response)
        dispatchError({ type: "ERROR", val: error.response })
      })
      .finally(() => {
        setResetForm(state => {
          return state + 1
        })
        setLoading(false)
        setResetPassSend(true)
      })
  }

  const changeForgottenPasss = async data => {
    setLoading(true)
    axios
      .post("https://montessori-back.herokuapp.com/api/auth/reset-password", {
        code: data.token,
        password: data.pass,
        passwordConfirmation: data.pass,
      })
      .then(response => {
        // Handle success.
        console.log("Your user's password has been changed.")
      })
      .catch(error => {
        // Handle error.
        console.log("An error occurred:", error.response)
      })
      .finally(() => {
        setpassChanged(true)
        setResetForm(state => {
          return state + 1
        })
        setLoading(false)
      })
  }

  useEffect(() => {
    autoLogIn()
  }, [])

  // CHANGE FROM

  const changeForm = mode => {
    if (mode === "signin") {
      setSignInMode(true)
    } else if (mode === "registration") {
      setSignInMode(false)
    } else {
      setSignInMode(!signInMode)
    }

    setResetForm(state => {
      return state + 1
    })
  }

  //COMMENTS

  const [refreshCommetnsCounter, setRefreshCommetnsCounter] = useState(1)
  const [navToNewPost, setNavToNewPost] = useState(null)

  //WATCHED VIDS

  const [watchedVids, setWatchedVids] = useState(null)

  const getWatchedVids = async () => {
    // axios
    //   .get(
    //     `https://montessori-back.herokuapp.com/api/users/${userGlobalState.userId}`,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${userGlobalState.token}`,
    //       },
    //     }
    //   )
    //   .then(response => {
    //     setWatchedVids(JSON.parse(response.data.watched_videos))
    //     console.log(response)
    //     console.log(response.data.watched_videos)
    //     console.log("WV request")
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
    //   .finally(() => {})

    const myHeaders = new Headers()
    myHeaders.append("Authorization", `Bearer ${userGlobalState.token}`)

    const formdata = new FormData()
    formdata.append("userId", `${userGlobalState.userId}`)
    // formdata.append("watched_videos", `${JSON.stringify(watchedArray)}`)
    // formdata.append("mode", `ADD`)
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    }

    fetch(`https://montessori-back.herokuapp.com/api/watched`, requestOptions)
      .then(response => response.text())
      .then(result => {
        const watched = JSON.parse(result)

        if (Array.isArray(watched)) {
          setWatchedVids(watched)
        }
      })
      .catch(error => console.log("error", error))
      .finally(() => {})
  }

  useEffect(() => {
    if (userGlobalState) {
      getWatchedVids()
    }
  }, [userGlobalState])

  //Date testing
  // console.log(new Date().toLocaleString('en-GB', { timeZone: "Europe/Sofia" }));

  return (
    <Context.Provider
      value={{
        logedIn,
        signInTest,
        sendAccData,
        signUpChildHandler,
        resetError,
        changeForm,
        userGlobalState,
        logInHandler,
        loading,
        errorState,
        resetForm,
        nameDuplication,
        signInMode,
        resetPassSend,
        setResetPassSend,
        registerMailSend,
        setRegiserMailSend,
        passChanged,
        setpassChanged,
        resetNameDupCheck,
        sendForgottenPasss,
        changeForgottenPasss,
        setResetPassSend,
        logOutHandler,
        //comments
        refreshCommetnsCounter,
        setRefreshCommetnsCounter,
        navToNewPost,
        setNavToNewPost,
        //watched vids
        watchedVids,
        getWatchedVids,
      }}
    >
      {props.children}
    </Context.Provider>
  )
}

export default UserProvider
